import React, { Component } from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { isMobile } from 'react-device-detect';
import { Dialog as DialogPrime } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Button as ButtonPrime } from 'primereact/button';
import ViewHeadlineIcon from '@material-ui/icons/ViewHeadline';
import IconButton from '@material-ui/core/IconButton';
import Anotacao from './Anotacao';
import { tema } from '../../util';

class BotaoMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      anchorMenuAcoes: false,
      redirecionaWizard: false,
      abreAnotacoes: false,
      dataConfirmadaCirurgia: null,
      dataConfirmadaInternacao: null,
      codigoLeitoInternacao: undefined,
      abreMensagemErro: false,
      mensagemErro: '',
      tituloErro: '',
    };
  }

  handleAbreAnotacoes = () => {
    this.setState({
      abreAnotacoes: true,
      anchorMenuAcoes: null,
    });
  };

  renderFooterDisplayErro = () => {
    return (
      <div>
        <ButtonPrime
          label="OK"
          icon="pi pi-check"
          onClick={() => this.setState({ abreMensagemErro: false })}
          autoFocus
        />
      </div>
    );
  };

  render() {
    if (this.state.redirecionaWizard) {
      this.props.setRenderWizardGerente(true);
    }
    return (
      <>
        <Toast
          ref={el => {
            this.toastTL = el;
          }}
          position="top-left"
        />
        <DialogPrime
          header={this.state.tituloErro}
          visible={this.state.abreMensagemErro}
          style={{ width: '50vw' }}
          onHide={() => this.setState({ abreMensagemErro: false })}
          footer={this.renderFooterDisplayErro()}
        >
          <div>
            <span style={{ whiteSpace: 'pre-line' }}>{this.state.mensagemErro}</span>
          </div>
        </DialogPrime>
        <DialogPrime
          header="Anotações"
          visible={this.state.abreAnotacoes}
          style={{ width: '65vw' }}
          onHide={() => this.setState({ abreAnotacoes: false })}
        >
          <>
            <Anotacao
              demanda={this.props.rowData.id}
              profissionalObservador={this.props.profissionalObservador}
            />
          </>
        </DialogPrime>
        <span className="p-column-title">Ações</span>
        <span style={{ margin: 'auto' }}>
          <IconButton
            onClick={event => this.setState({ anchorMenuAcoes: event.currentTarget })}
            style={{ marginRight: '1px', backgroundColor: tema.gelado, color: 'white' }}
            className="botao-favoritos"
          >
            <ViewHeadlineIcon />
          </IconButton>
          <Menu
            id="menu-acao-pedidos-cirurgias"
            anchorEl={this.state.anchorMenuAcoes}
            keepMounted
            open={Boolean(this.state.anchorMenuAcoes)}
            onClose={() => this.setState({ anchorMenuAcoes: null })}
            MenuListProps={{ style: { width: isMobile ? '60vw' : '20vw' } }}
          >
            <MenuItem
              style={{ borderBottom: 'solid #e7e7e7 1px' }}
              key={`anotacao${this.props.rowData.codigo}`}
              onClick={() => this.handleAbreAnotacoes()}
            >
              Anotações
            </MenuItem>
          </Menu>
        </span>
      </>
    );
  }
}

export default BotaoMenu;
